import { render } from "./SubcategoryTagEdit.vue?vue&type=template&id=5f418468"
import script from "./SubcategoryTagEdit.vue?vue&type=script&lang=js"
export * from "./SubcategoryTagEdit.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__